// client_serena/src/pages/Signup.js
import React, { useState } from "react";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import { Box, Heading, Input, Button, Divider, Text, VStack } from "@chakra-ui/react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function Signup() {
const [formData, setFormData] = useState({ email: "", password: "" });
const [loading, setLoading] = useState(false);
const navigate = useNavigate();

const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

const handleSignup = async (e) => {
e.preventDefault();
setLoading(true);
try {
const { email, password } = formData;
const userCred = await createUserWithEmailAndPassword(auth, email, password);
await setDoc(doc(db, "users", userCred.user.uid), {
email: userCred.user.email,
role: "user",
createdAt: new Date(),
});

// Create user profile in backend
await fetch(`${API_BASE_URL}/api/user/create-profile`, {
method: "POST",
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${await userCred.user.getIdToken()}`,
},
body: JSON.stringify({ email: userCred.user.email }),
});

navigate("/onboarding");
} catch (err) {
alert(err.message);
} finally {
setLoading(false);
}
};

const handleGoogleSignup = async () => {
setLoading(true);
try {
const provider = new GoogleAuthProvider();
const result = await signInWithPopup(auth, provider);
await setDoc(doc(db, "users", result.user.uid), {
email: result.user.email,
role: "user",
createdAt: new Date(),
}, { merge: true });

await fetch(`${API_BASE_URL}/api/user/create-profile`, {
method: "POST",
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${await result.user.getIdToken()}`,
},
body: JSON.stringify({ email: result.user.email }),
});

navigate("/onboarding");
} catch (err) {
alert(err.message);
} finally {
setLoading(false);
}
};

return (
<Box maxW="sm" mx="auto" mt={12} p={6} borderRadius="lg" boxShadow="md" bg="white">
<Heading mb={4} color="teal.600">Sign Up</Heading>
<form onSubmit={handleSignup}>
<VStack spacing={4} align="stretch">
<Input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
<Input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
<Button type="submit" colorScheme="teal" isLoading={loading} width="full">Sign Up</Button>
</VStack>
</form>
<Divider my={4} />
<Button onClick={handleGoogleSignup} colorScheme="red" width="full" isLoading={loading}>
Sign Up with Google
</Button>
<Text fontSize="sm" mt={4} textAlign="center">
Already have an account? <Link to="/login" style={{ color: "#319795", fontWeight: 500 }}>Login</Link>
</Text>
<Text fontSize="xs" color="gray.400" mt={2} textAlign="center">
By signing up, you agree to our <Link to="/app/privacy" style={{ color: "#319795", fontWeight: 500 }}>Privacy Policy</Link>.
</Text>
</Box>
);
}
